import { POST, YT_POST_TYPES } from '@/lib/posts/postTypes';

import { mediaViewerViewsConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerViews';
import { mediaViewerViewsRate } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerViewsRate';
import { mediaViewerLikesConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerLikes';
import { mediaViewerCommentsConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerComments';
import { mediaViewerSharesConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerShares';
import { mediaViewerVideoDuration } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerVideoDuration';
import { mediaViewerVideoViewsTotalTimeConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerVideoViewsTotalTime';
import { mediaViewerVideoViewsAvgTimeWatchedConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerVideoViewsAvgTimeWatched';

import { mediaLifeSpanMVConfig } from '@/lib/analytics/charts/youtube/mediaViewer/mediaLifeSpan';

const VIDEO_CONFIG = [
    mediaViewerViewsConfig,
    mediaViewerLikesConfig,
    mediaViewerVideoViewsTotalTimeConfig,
    mediaViewerVideoViewsAvgTimeWatchedConfig,
    mediaViewerCommentsConfig,
    mediaViewerSharesConfig,
    mediaViewerViewsRate,
    mediaViewerVideoDuration,
    mediaLifeSpanMVConfig
];

export const MediaViewerStatsYoutube = {
    [POST]: {
        [YT_POST_TYPES.TYPE_VIDEO]: VIDEO_CONFIG,
        [YT_POST_TYPES.TYPE_SHORT]: VIDEO_CONFIG
    }
};
